import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-declaration-modal',
  template:  `
  <app-form-iframe [iFrameLink] = url></app-form-iframe>
`,
  styleUrls: []
})
export class DeclarationModalComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() url: string;

  isIframeLoading = true;

  constructor() {}

  ngOnInit() {
    console.log(this.url)
  }

  iframeLoadingEvent(){
    this.isIframeLoading = false;
  }

}

